'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rhythmUnitsToEmsTransformer = require('../transformers/rhythmUnitsToEmsTransformer');

var _rhythmUnitsToEmsTransformer2 = _interopRequireDefault(_rhythmUnitsToEmsTransformer);

var _unitlessNumberToEmsTransformer = require('./unitlessNumberToEmsTransformer');

var _unitlessNumberToEmsTransformer2 = _interopRequireDefault(_unitlessNumberToEmsTransformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lengthToRemsTransformer = [_unitlessNumberToEmsTransformer2.default, _rhythmUnitsToEmsTransformer2.default];

exports.default = lengthToRemsTransformer;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/transformers/lengthToEmsTransformer.js
// module id = 670
// module chunks = 168707334958949